import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { MessageBarBody, MessageBarTitle } from '@fluentui/react-components';
import { GuideDrawer } from '../../../theme/components/GuideDrawer';
import { GuideMessageBar } from '../../../theme/components/GuideMessageBar';
import { useTranslation } from 'react-i18next';
import * as ComponentFunctions from './Protocol.ExportVisit.Form.Functions';
import { IConsumptionsFilters } from '../../../models/Filters/ConsumptionsFilters';
import { DateTimeInput } from '../../../commons/component/Inputs/DateTimeInput/DateTimeInput';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProtocolExportVisitFormComponentCode = (props: ComponentFunctions.Props & DrawerProps) => {
  const [t] = useTranslation();
  const [dateFrom, setDateFrom] = useState<Date | undefined>(undefined);
  const [dateTo, setDateTo] = useState<Date | undefined>(undefined);
  const [filterText, setFilterText] = useState<string>('');

  // Descarga automática cuando el blob esté disponible y cierra el drawer
  useEffect(() => {
    if (props.FileBlob) {
      downloadFile(props.FileBlob);
      // Cerrar el drawer después de iniciar la descarga
      setTimeout(() => {
        props.onClose();
      }, 500);
    }
  }, [props.FileBlob]);

  const downloadFile = (blob: Blob) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `ProtocolVisits_${new Date().getTime()}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleExport = () => {
    const filters: IConsumptionsFilters = {
      SelectedConsumptions: [],
      SelectedProtocolPatients: [],
      SelectedContractConcepts: [],
      SelectedCurrencys: '',
      SelectedContractStages: [],
      SelectedPractitioners: [],
      SelectedStatus: [],
      SelectedProtocols: [],
      SelectedSettlements: [],
      SelectedDateRange: [dateFrom, dateTo],
      FilterText: filterText || undefined,
      ignoreVisitConsumption: false,
      showGroupedByVisit: false,
      GroupId: undefined
    };

    props.ExportProtocolVisitsToExcel(filters);
  };

  const isFormValid = () => {
    return dateFrom && dateTo && dateTo >= dateFrom;
  };

  return (
    <GuideDrawer
      open={props.isOpen}
      size="small"
      title={t('protocolExportVisitForm.title')}
      onDismiss={props.onClose}
      testId="protocol-export-visits-drawer"
      secondaryAction={{ label: t('protocolExportVisitForm.cancel') }}
      primaryAction={{
        label: props.isGenerating ? t('protocolExportVisitForm.generatingFile') : t('protocolExportVisitForm.exportToExcel'),
        onClick: handleExport,
        disabled: !isFormValid(),
        loading: props.isGenerating,
      }}
    >
      {props.error && (
        <GuideMessageBar intent="error">
          <MessageBarBody>
            <MessageBarTitle>{t('protocolExportVisitForm.error')}</MessageBarTitle>
            {props.error.ErrorMessage}
          </MessageBarBody>
        </GuideMessageBar>
      )}

      <DateTimeInput
        label={t('protocolExportVisitForm.dateFrom')}
        placeHolder={t('protocolExportVisitForm.selectStartDate')}
        selectedDate={dateFrom}
        isSubmitted={false}
        isRequired={true}
        errorMessage={undefined}
        onSelectDate={setDateFrom}
      />
      <DateTimeInput
        label={t('protocolExportVisitForm.dateTo')}
        placeHolder={t('protocolExportVisitForm.selectEndDate')}
        selectedDate={dateTo}
        isSubmitted={false}
        isRequired={true}
        errorMessage={undefined}
        onSelectDate={setDateTo}
      />
    </GuideDrawer>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(ProtocolExportVisitFormComponentCode as any);

